//this file has all theh utility functions

import { getActiveBranchIds1 } from "../multipleBranch/getActiveBranchId";

// required to calculate attribution analysis (plus repeat customer ratio) BOTH
export function repeatCustomer(data, mode = "regular") {
  // this function will run whenever fetch data button is pressed.
  // and we store calculated data in session storage branch wise.

  if (data.length == 0) return null;
  let activeBranches = getActiveBranchIds1();

  let extractedData = [];

  activeBranches.forEach((branchId) => {
    let obj = {
      branchId: branchId,
      bdata: [],
    };

    let extractedBranchData = extractDataBranchwise(data, branchId);
    obj.bdata.push(extractedBranchData);

    extractedData.push(obj);
  });

  // data extraction branch wise done..
  // if attribution data doesnt exist

  //console.log(extractedData);

  if (extractedData.length == 0) return null;

  // looping branchces to calculate data.

  let outputData = [];

  activeBranches.forEach((branch) => {
    let obj = {
      branchId: branch,
    };

    let attributionData = calculateAttributionData(extractedData, branch);
    obj.repeatCustomerData = calculateRepeatCustomer(extractedData, branch);

    obj.attributionData = attributionData;

    outputData.push(obj);
  });

  if (mode == "regular")
    // other mode is report for report section calculation
    sessionStorage.setItem("attribution", JSON.stringify(outputData));
  return outputData;
}

function extractDataBranchwise(inputData, bId) {
  // here we just extract from data in storage
  // we extract admin_id(branch id ) and attribution field

  // looping through data

  let outputD = [];

  inputData?.forEach((item) => {
    if (item.admin_id == bId) {
      outputD.push(item.data.attribution);
    }
  });
  //console.log(outputD);

  return outputD;
}

function calculateRepeatCustomer(inputData, branchId) {
  // this function inputs extracted formatted data with branch id and
  // calculate the repeat customer %.

  // format of iniput data is array of array
  // let inputdata = [["No","socialmedia"],["Yes","none"],[]]

  let data = [];
  inputData.forEach((item) => {
    if (item.branchId == branchId) {
      data = item.bdata[0];
    }
  });
  let totalResponse = data.length;
  let repeatNumber = 0;

  data.forEach((item) => {
    if (item[0] == "Yes") {
      repeatNumber++;
    }
  });
  let totalResponse1 = totalResponse;
  if (totalResponse1 == 0) totalResponse1 = 1;

  let repPercent = ((repeatNumber / totalResponse1) * 100).toFixed(2);

  return { totalResponse: totalResponse, repeatPercent: repPercent };
}

function calculateAttributionData(inputData, branchId) {
  // first get options to question asking attribution question
  // from questions stored in localstorage.
console.log(" calculate attribution data called");
console.log(inputData);
console.log("flage xxxxyyy")
let questions = JSON.parse(localStorage.getItem("questions"))
console.log(questions)
console.log(questions.attribution[1]?.options)
  let optionsArr = JSON.parse(localStorage.getItem("questions")).attribution[1]
    ?.options;
  console.log(optionsArr);
  console.log("flag XXX")
  //console.log(optionsArr);
  if (optionsArr == undefined) return null;
  let responseArr = [0, 0, 0, 0];
  //console.log(inputData);
  let data = [];
  inputData.forEach((item) => {
    if (item.branchId == branchId) {
      data = item.bdata[0];
    }
  });
  //console.log(data);
  // counting all the frequecy matches of answers.
  data.forEach((item) => {
    let ind = optionsArr.indexOf(item[1]);

    if (ind >= 0) {
      responseArr[ind]++;
    }
  });
  let totalResponse = data.length;
  let outputPercentage = [0, 0, 0, 0];
  let totalResponse1 = totalResponse;
  if (totalResponse1 == 0) totalResponse1 = 1;
  responseArr.forEach((value, index) => {
    let pValue = (value / totalResponse1 * 100).toFixed(2);

    outputPercentage[index] = pValue;
  });

  return {
    totalResponse: totalResponse,
    options: optionsArr,
    attribution: outputPercentage,
  };
}
